import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

function Pricing() {
  return (
    <section className="pricing">
      <div className="pricing-inner">

        <div className="pricing-headline reveal">
          <h2>Simple Pricing. <span className="pricing-em">Real</span> Ownership.</h2>
          <p className="pricing-lead">
            One setup fee. One monthly rate. No per-token billing. No surprises.
            Your model, your servers, your data.
          </p>
        </div>

        {/* Community / Open Source */}
        <div className="pricing-community reveal">
          <span className="pricing-community-badge">Community (Free)</span>
          <div className="pricing-community-grid">
            <div className="pricing-community-left">
              <div className="pricing-community-price">$0</div>
              <div className="pricing-community-label">Open source, self-hosted</div>
              <div className="pricing-community-license">Apache 2.0 License</div>
              <div className="pricing-community-note">USA only. pip install uses geolocation enforcement.</div>
              <a
                href="https://code.aetherprotocols.com/nexusconcordat/aether-nlm"
                className="pricing-community-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Source on GitLab
              </a>
            </div>
            <div className="pricing-community-right">
              <ul className="pricing-feature-list">
                <li>34-head Neurochemical Conductance Architecture</li>
                <li>Hodgkin-Huxley conductance gating</li>
                <li>Fit test suite (7 test suites)</li>
                <li>SIRA audit trail module</li>
                <li>Source code on GitLab (free account required)</li>
                <li>Community support only</li>
              </ul>
              <p className="pricing-community-fine">
                Apoptotic safety, dendritic nanotube network, genesis cell training,
                signal transduction, and the proprietary lexicon are only available
                in paid tiers.
              </p>
            </div>
          </div>
        </div>

        {/* Beta Banner */}
        <div className="pricing-beta reveal">
          <span className="pricing-beta-badge">Founding Client Program</span>
          <h3>First 10 Clients. Locked Beta Pricing.</h3>
          <p>
            We are onboarding 10 founding clients at reduced rates. You get early access
            to patent-pending NLM technology and a permanently locked rate. We get
            real-world deployment partners.
          </p>

          <div className="pricing-beta-row">
            <div className="pricing-beta-box">
              <span className="pricing-beta-label">Setup + Training</span>
              <span className="pricing-beta-was">$3,500</span>
              <span className="pricing-beta-now">$1,500</span>
              <span className="pricing-beta-note">One-time</span>
            </div>
            <div className="pricing-beta-box">
              <span className="pricing-beta-label">NLM License</span>
              <span className="pricing-beta-was">$99/mo</span>
              <span className="pricing-beta-now">$49/mo</span>
              <span className="pricing-beta-note">6-month commitment</span>
            </div>
          </div>

          <div className="pricing-beta-includes">
            <span><span className="ck">+</span> Up to 500 MB training data</span>
            <span><span className="ck">+</span> ~500,000 training pairs prepared</span>
            <span><span className="ck">+</span> Genesis cell training included</span>
            <span><span className="ck">+</span> Automated weekly retraining</span>
            <span><span className="ck">+</span> Deployment to your hardware</span>
            <span><span className="ck">+</span> Staff training (2 hours)</span>
            <span><span className="ck">+</span> Priority support</span>
            <span><span className="ck">+</span> Rate locked for life</span>
            <span><span className="ck">+</span> Additional data: $5/MB</span>
            <span><span className="ck">+</span> Simple HTML interface included</span>
          </div>

          <div className="pricing-beta-slots">
            <div className="pricing-slot-track"><div className="pricing-slot-fill"></div></div>
            <span className="pricing-slot-text">10 spots available</span>
          </div>
        </div>

        {/* Standard Tiers */}
        <div className="pricing-tiers reveal">
          <div className="pricing-card">
            <span className="pricing-tier-label">Starter</span>
            <div className="pricing-setup">$3,500</div>
            <div className="pricing-setup-sub">one-time setup</div>
            <div className="pricing-monthly">$99/mo</div>
            <div className="pricing-monthly-sub">NLM license</div>
            <div className="pricing-data-badge">Up to 500 MB training data included</div>
            <ul className="pricing-feature-list">
              <li>Single-domain genesis cells</li>
              <li>Dendritic nanotube network</li>
              <li>Apoptotic safety mechanisms</li>
              <li>Data assessment + preparation</li>
              <li>Deployment to your hardware</li>
              <li>2-hour staff training</li>
              <li>Automated weekly retraining</li>
              <li>Simple HTML interface included</li>
              <li>Email support</li>
            </ul>
          </div>

          <div className="pricing-card pricing-featured">
            <span className="pricing-tier-label">Professional</span>
            <div className="pricing-setup">$7,500</div>
            <div className="pricing-setup-sub">one-time setup</div>
            <div className="pricing-monthly">$249/mo</div>
            <div className="pricing-monthly-sub">NLM license</div>
            <div className="pricing-data-badge">Up to 2 GB training data included</div>
            <ul className="pricing-feature-list">
              <li>Multi-domain genesis cells</li>
              <li>Dendritic nanotube network</li>
              <li>Apoptotic safety mechanisms</li>
              <li>API integration into your systems</li>
              <li>Automated daily retraining</li>
              <li>4-hour staff training</li>
              <li>Priority support</li>
              <li>Usage analytics dashboard</li>
            </ul>
          </div>

          <div className="pricing-card">
            <span className="pricing-tier-label">Enterprise</span>
            <div className="pricing-setup">$15,000+</div>
            <div className="pricing-setup-sub">one-time setup</div>
            <div className="pricing-monthly">$599/mo</div>
            <div className="pricing-monthly-sub">NLM license</div>
            <div className="pricing-data-badge">Up to 10 GB training data included</div>
            <ul className="pricing-feature-list">
              <li>Multiple genesis cell domains</li>
              <li>Dendritic nanotube network</li>
              <li>Apoptotic safety mechanisms</li>
              <li>Signal transduction pipeline</li>
              <li>Multi-department deployment</li>
              <li>Real-time automated retraining</li>
              <li>On-site training sessions</li>
              <li>Dedicated support + SLA</li>
              <li>Audit trail + compliance reporting</li>
            </ul>
          </div>
        </div>

        {/* Custom UI */}
        <div className="pricing-section reveal">
          <h3>Custom Interface Options</h3>
          <p className="pricing-section-sub">
            Every NLM deployment includes a simple query interface. Need more?
            We build to fit your workflow.
          </p>

          <div className="pricing-tiers">
            <div className="pricing-card">
              <span className="pricing-tier-label">Simple HTML</span>
              <div className="pricing-setup">Included</div>
              <div className="pricing-setup-sub">with any tier</div>
              <div className="pricing-monthly">$0/mo</div>
              <div className="pricing-monthly-sub">no extra cost</div>
              <ul className="pricing-feature-list">
                <li>Clean query interface</li>
                <li>Response display</li>
                <li>Mobile responsive</li>
                <li>Your branding</li>
              </ul>
            </div>

            <div className="pricing-card pricing-featured">
              <span className="pricing-tier-label">Full Web App</span>
              <div className="pricing-setup">$2,500+</div>
              <div className="pricing-setup-sub">one-time build</div>
              <div className="pricing-monthly">+$29/mo</div>
              <div className="pricing-monthly-sub">over 30 users</div>
              <ul className="pricing-feature-list">
                <li>React frontend + backend</li>
                <li>Multi-page layout</li>
                <li>Sidebar navigation</li>
                <li>User authentication</li>
                <li>Role-based access</li>
                <li>Under 30 users: no monthly add-on</li>
              </ul>
            </div>

            <div className="pricing-card">
              <span className="pricing-tier-label">Enterprise Platform</span>
              <div className="pricing-setup">$5,000+</div>
              <div className="pricing-setup-sub">one-time build</div>
              <div className="pricing-monthly">+$49/mo</div>
              <div className="pricing-monthly-sub">over 30 users</div>
              <ul className="pricing-feature-list">
                <li>Everything in Full Web App</li>
                <li>Email integration</li>
                <li>Dashboard + analytics</li>
                <li>Multi-department views</li>
                <li>Custom workflow automation</li>
                <li>API endpoints for your systems</li>
              </ul>
            </div>
          </div>

          <p className="pricing-fine">
            Interface complexity is scoped per project. More pages, more components,
            more integrations = higher build cost. The monthly add-on for React apps
            only applies above 30 users and covers additional server load and session management.
          </p>
        </div>

        {/* Data & Training */}
        <div className="pricing-section reveal">
          <h3>Data Sizing + Training Pair Preparation</h3>
          <p className="pricing-section-sub">
            Most private AI vendors bolt a retrieval layer (RAG) onto a generic model.
            We don't. Our patent-pending genesis cell architecture trains specialized
            neural cells directly on your domain data. Your knowledge becomes part of
            the model's structure, not a search index it queries at runtime.
          </p>

          <div className="pricing-data-table">
            <div className="pricing-data-header">
              <span>Tier</span>
              <span>Raw Data</span>
              <span>Training Pairs</span>
              <span>Prep Time</span>
              <span>Retraining</span>
            </div>
            <div className="pricing-data-row">
              <span>Beta ($49/mo)</span>
              <span>Up to 500 MB</span>
              <span>~500,000 pairs</span>
              <span>4-6 hours</span>
              <span>Auto weekly</span>
            </div>
            <div className="pricing-data-row">
              <span>Starter ($99/mo)</span>
              <span>Up to 500 MB</span>
              <span>~500,000 pairs</span>
              <span>4-6 hours</span>
              <span>Auto weekly</span>
            </div>
            <div className="pricing-data-row">
              <span>Professional ($249/mo)</span>
              <span>Up to 2 GB</span>
              <span>~2,000,000 pairs</span>
              <span>12-18 hours</span>
              <span>Auto daily</span>
            </div>
            <div className="pricing-data-row">
              <span>Enterprise ($599/mo)</span>
              <span>Up to 10 GB</span>
              <span>~10,000,000 pairs</span>
              <span>40-60 hours</span>
              <span>Auto real-time</span>
            </div>
          </div>

          <p className="pricing-fine" style={{marginTop: '0.5rem'}}>
            Prep time covers document analysis, format conversion, training pair
            extraction, quality review, and validation. Included in your tier's setup
            fee. Additional data prep billed at $5/MB.
          </p>

          <div className="pricing-compute-box">
            <h4>Specialized Cell Training: $2.50/hour</h4>
            <p>
              We don't retrain the entire model from scratch. Our architecture trains
              only the specialized cells relevant to your domain. A healthcare client's
              model trains medical terminology cells. A legal client trains contract
              analysis cells. The core architecture stays intact. Faster training,
              lower cost, and a model that gains expertise without losing stability.
            </p>
            <div className="pricing-compute-examples">
              <div className="pricing-compute-item">
                <span className="pricing-compute-label">500 MB / ~500K pairs</span>
                <span className="pricing-compute-value">~4-6 hrs = $10-15</span>
              </div>
              <div className="pricing-compute-item">
                <span className="pricing-compute-label">2 GB / ~2M pairs</span>
                <span className="pricing-compute-value">~12-18 hrs = $30-45</span>
              </div>
              <div className="pricing-compute-item">
                <span className="pricing-compute-label">10 GB / ~10M pairs</span>
                <span className="pricing-compute-value">~40-60 hrs = $100-150</span>
              </div>
            </div>
            <p className="pricing-fine">
              Initial training compute is included in your setup fee. This rate applies
              to retraining beyond your tier's included allowance and additional data orders.
            </p>
          </div>

          <div className="pricing-breakdown-grid">
            <div className="pricing-breakdown-card">
              <h4>Additional Training Data</h4>
              <p><strong>$5/MB</strong> beyond your tier's included allowance. Rate
              includes data cleaning, training pair extraction, quality review, and
              model retraining. Minimum 50 MB per order.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>What Counts as Training Data</h4>
              <p>PDFs, Word docs, spreadsheets, email archives, internal wikis, SOPs,
              manuals, chat logs. Any structured or unstructured text your team works
              with. We handle the conversion.</p>
            </div>
          </div>
        </div>

        {/* What's in Setup */}
        <div className="pricing-section reveal">
          <h3>What's in the Setup Fee</h3>
          <div className="pricing-breakdown-grid">
            <div className="pricing-breakdown-card">
              <h4>Data Assessment</h4>
              <p>We evaluate your existing documentation, processes, and systems. We
              identify what the model needs to learn and what format it's in.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>Data Preparation</h4>
              <p>Your raw documents get cleaned, structured, and formatted for training.
              Domain-specific terminology is preserved. Sensitive fields are handled
              according to your compliance requirements.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>Genesis Cell Training</h4>
              <p>Specialized neural cells are trained on your domain data using our
              patent-pending architecture. Your knowledge lives inside the model's
              structure. No RAG. No retrieval latency. Deeper comprehension than
              retrieval-based approaches.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>Deployment + Training</h4>
              <p>The model is installed on your hardware, tested with your team, and
              your staff is trained on how to use it. You get documentation and direct
              support through the transition.</p>
            </div>
          </div>
        </div>

        {/* What's in Monthly */}
        <div className="pricing-section reveal">
          <h3>What's in the Monthly</h3>
          <p className="pricing-section-sub">
            Your monthly fee is a <strong>license</strong> for patent-pending NLM
            technology that exists nowhere else. It includes:
          </p>
          <div className="pricing-breakdown-grid pricing-breakdown-3">
            <div className="pricing-breakdown-card">
              <h4>NLM Technology License</h4>
              <p>Access to patent-pending Neurochemical Language Model architecture.
              Three U.S. provisional patents protect the genesis cell training,
              cascading hierarchy, and signal transduction systems your model runs on.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>Automated Retraining</h4>
              <p>Your usage data generates new training pairs automatically via
              monitoring daemons. The model retrains on your evolving data at your
              tier's frequency: weekly, daily, or real-time. No manual intervention.
              The model gets smarter as you use it.</p>
            </div>
            <div className="pricing-breakdown-card">
              <h4>Support + Architecture Updates</h4>
              <p>Bug fixes, performance tuning, and core architecture improvements.
              When we advance the underlying NLM technology, your model benefits.
              You are never stuck on a deprecated version.</p>
            </div>
          </div>
        </div>

        {/* The Math */}
        <div className="pricing-math reveal">
          <h3>The Math: API Costs vs. Private NLM</h3>
          <div className="pricing-math-rows">
            <div className="pricing-math-row">
              <span className="pricing-math-label">GPT-4o API (Year 1, 10 users)</span>
              <span className="pricing-math-value">$600 - $3,600+ and growing</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Private NLM Starter (Year 1)</span>
              <span className="pricing-math-value">$3,500 + $1,188 = $4,688</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Private NLM Starter (Year 2+)</span>
              <span className="pricing-math-value">$1,188/year (flat, gets smarter)</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Beta Client (Year 1)</span>
              <span className="pricing-math-value">$1,500 + $588 = $2,088</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Beta Client (Year 2+)</span>
              <span className="pricing-math-value">$588/year (locked for life)</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">API model learns from your data?</span>
              <span className="pricing-math-value">No. Same generic model forever.</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Private NLM learns from your data?</span>
              <span className="pricing-math-value">Yes. Gets smarter every week.</span>
            </div>
            <div className="pricing-math-row">
              <span className="pricing-math-label">Data exposure with API</span>
              <span className="pricing-math-value">Every query leaves your network</span>
            </div>
            <div className="pricing-math-row pricing-math-final">
              <span className="pricing-math-label">Data exposure with Private NLM</span>
              <span className="pricing-math-value">Zero. Nothing leaves your building.</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="pricing-cta reveal">
          <h3>Let's Build Yours</h3>
          <p>Tell us about your business and we'll scope a private AI deployment for your team.</p>
          <a className="pricing-cta-btn" href="mailto:caelsereith@aetherprotocols.com?subject=Private%20AI%20-%20Pricing%20Inquiry">
            Get Started
          </a>
          <div className="pricing-cta-email">caelsereith@aetherprotocols.com</div>
          <p className="pricing-fine" style={{marginTop: '1rem'}}>
            Looking to sponsor production infrastructure?{' '}
            <Link to="/fund-us" style={{color: 'var(--gold)'}}>View sponsorship tiers</Link>
          </p>
        </div>

        <div className="pricing-footer-note">
          &copy; 2026 Nexus Concordat. All rights reserved. Patent pending.
          Private AI solutions powered by Aether Protocols.
        </div>

      </div>
    </section>
  );
}

export default Pricing;
